import { useMemo } from "react";
import DataSourceControlsGrid from "./DataSourceControlsGrid";
import DataSourceScheduleModal from "./DataSourceScheduleModal";
import { mapFoodSourceToGridRow } from "./mapDataSourceGridRow";
import { useOverlaySourceSchedule } from "./useOverlaySourceSchedule";

export default function FoodSourceControlsGrid({
  sources,
  emptyMessage,
  canManageSources,
  busyCode,
  runningCode,
  onToggleEnabled,
  onRunNow,
  onViewRuns,
  resolveRunNowTitle,
  onRefresh,
  showToast,
  onSourcePatch,
}) {
  const { scheduleSource, setScheduleSource, scheduleSaving, handleSaveSchedule } =
    useOverlaySourceSchedule({
      domain: "food",
      onRefresh,
      showToast,
      onScheduleSaved: (source, schedule) => {
        onSourcePatch?.(source.sourceCode || source.sourceKey, {
          scheduleEnabled: schedule.scheduleEnabled,
          scheduleIntervalMinutes: schedule.scheduleIntervalMinutes,
          scheduleCronExpression: schedule.scheduleCronExpression,
          nextRunAt: schedule.nextRunAt,
          supportsSchedule: true,
        });
      },
    });

  const rows = useMemo(
    () => (sources || []).map((source) => mapFoodSourceToGridRow(source)),
    [sources]
  );

  return (
    <>
      <DataSourceControlsGrid
        sources={rows}
        emptyMessage={emptyMessage}
        busyKey={runningCode || busyCode}
        canManageSources={canManageSources}
        onToggleEnabled={onToggleEnabled}
        onRunNow={onRunNow}
        onSaveSchedule={handleSaveSchedule}
        onViewRuns={onViewRuns}
        deleteDomain="food"
        onDeleted={() => onRefresh?.()}
        onRefresh={onRefresh}
        showToast={showToast}
        resolveRunNowTitle={resolveRunNowTitle}
      />
      <DataSourceScheduleModal
        source={scheduleSource}
        isOpen={Boolean(scheduleSource)}
        isSaving={scheduleSaving}
        onClose={() => setScheduleSource(null)}
        onSave={handleSaveSchedule}
      />
    </>
  );
}
